import React from "react";
import { Card, CardBody, Collapse, Form, FormGroup, Input, Label, Button, Row, Col } from "reactstrap";

const FiltroFichaje = (props) => {
  const [showTraceabilityOptions, setShowTraceabilityOptions] = React.useState(false);
  const hasTraceabilitySelector = typeof props.setEstadoVista === "function";
  const hasManualToggle = typeof props.setShowManualOptions === "function";

  return (
    <>
      <Card>
        <CardBody>
          <Form>
            <Row>
              <Col md="6" sm="12">
                <FormGroup>
                  <Label>Fecha desde</Label>
                  <Input type="date" value={props.fechaDesde} onChange={(e) => props.setFechaDesde(e.target.value)} />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <Label>Fecha hasta</Label>
                  <Input type="date" value={props.fechaHasta} onChange={(e) => props.setFechaHasta(e.target.value)} />
                </FormGroup>
              </Col>
            </Row>
            {hasTraceabilitySelector || hasManualToggle ? (
              <FormGroup className="mb-0">
                <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
                  {hasTraceabilitySelector ? (
                    <Button
                      color="link"
                      className="p-0"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowTraceabilityOptions((prev) => !prev);
                      }}
                    >
                      Opciones de trazabilidad
                    </Button>
                  ) : null}
                  {hasManualToggle ? (
                    <Button
                      color="link"
                      className="p-0"
                      onClick={(e) => {
                        e.preventDefault();
                        props.setShowManualOptions((prev) => !prev);
                      }}
                    >
                      Opciones de fichaje manual
                    </Button>
                  ) : null}
                </div>
              </FormGroup>
            ) : null}
            {hasTraceabilitySelector ? (
              <Collapse isOpen={showTraceabilityOptions}>
                <FormGroup className="mt-2">
                  <Label>Mostrar fichajes</Label>
                  <Input
                    type="select"
                    value={props.estadoVista}
                    onChange={(e) => props.setEstadoVista(e.target.value)}
                  >
                    <option value="ACTIVOS">Activos</option>
                    <option value="ELIMINADOS">Eliminados</option>
                    <option value="TODOS">Todos</option>
                  </Input>
                </FormGroup>
              </Collapse>
            ) : null}
          </Form>
        </CardBody>
      </Card>
    </>
  );
};

export default FiltroFichaje;
